/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetAllRecruitmentMetaModel } from '../../entities/v1/GetAllRecruitmentMetaModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1GetAllRecruitmentMetaModelSchema = z.object({
  limit: z.number().int(),
  offset: z.number().int(),
  total: z.number().int(),
}) as unknown as ToZod<V1GetAllRecruitmentMetaModel>